/**
 * Used in NavigationState as an abstraction of configuration entities
 * @private Avoid using this in projects
 */
export var ConfigurationItemKind;
(function (ConfigurationItemKind) {
    ConfigurationItemKind["ConfigurationGroup"] = "ConfigurationGroup";
    ConfigurationItemKind["ConfigurationObject"] = "ConfigurationObject";
    ConfigurationItemKind["ConfigurationAttribute"] = "ConfigurationAttribute";
})(ConfigurationItemKind || (ConfigurationItemKind = {}));
//# sourceMappingURL=ConfigurationItemKind.js.map